module.exports = __webpack_public_path__ + "img/logo.e3083bd2.png";